export default __webpack_public_path__ + "static/media/heat-recovery-boiler.8090f2dd.jpg";